import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CustomSpinnerComponent } from './custom-spinner.component';

@NgModule({
  declarations: [CustomSpinnerComponent],
  imports: [CommonModule],
  exports: [CustomSpinnerComponent]
})
export class CustomSpinnerModule {}
